export enum RateType {
  None = 0,
  BaseRate = 1,
  AccessorialRate = 2,
  FuelSurcharge = 4,
  Taxes = 8,
  NoRate = 16
}

export enum VendorIntegrationType {
  None = 0,
  Edi = 1
}

export enum Source {
  Manual = 1,
  Scan = 2
}

export enum Status {
  Active = 1,
  InActive = 2
}

export enum Country {
  Select = -1,
  Canada = 1,
  UnitedStates = 2,
  Mexico = 3,
  Afghanistan = 4,
  Albania = 5,
  Algeria = 6,
  Andorra = 7,
  Angola = 8,
  AntiguaAndBarbuda = 9,
  Argentina = 10,
  Armenia = 11,
  Australia = 12,
  Austria = 13,
  Azerbaijan = 14,
  Bahamas = 15,
  Bahrain = 16,
  Bangladesh = 17,
  Barbados = 18,
  Belarus = 19,
  Belgium = 20,
  Belize = 21,
  Benin = 22,
  Bhutan = 23,
  Bolivia = 24,
  BosniaAndHerzegovina = 25,
  Botswana = 26,
  Brazil = 27,
  Brunei = 28,
  Bulgaria = 29,
  BurkinaFaso = 30,
  Burundi = 31,
  CaboVerde = 32,
  Cambodia = 33,
  Cameroon = 34,
  CentralAfricanRepublic = 35,
  Chad = 36,
  Chile = 37,
  China = 38,
  Colombia = 39,
  Comoros = 40,
  CongoDemocraticRepublic = 41,
  CongoRepublic = 42,
  CostaRica = 43,
  Croatia = 44,
  Cuba = 45,
  Cyprus = 46,
  CzechRepublic = 47,
  Denmark = 48,
  Djibouti = 49,
  Dominica = 50,
  DominicanRepublic = 51,
  EastTimor = 52,
  Ecuador = 53,
  Egypt = 54,
  ElSalvador = 55,
  EquatorialGuinea = 56,
  Eritrea = 57,
  Estonia = 58,
  Eswatini = 59,
  Ethiopia = 60,
  Fiji = 61,
  Finland = 62,
  France = 63,
  Gabon = 64,
  Gambia = 65,
  Georgia = 66,
  Germany = 67,
  Ghana = 68,
  Greece = 69,
  Grenada = 70,
  Guatemala = 71,
  Guinea = 72,
  GuineaBissau = 73,
  Guyana = 74,
  Haiti = 75,
  Honduras = 76,
  Hungary = 77,
  Iceland = 78,
  India = 79,
  Indonesia = 80,
  Iran = 81,
  Iraq = 82,
  Ireland = 83,
  Israel = 84,
  Italy = 85,
  IvoryCoast = 86,
  Jamaica = 87,
  Japan = 88,
  Jordan = 89,
  Kazakhstan = 90,
  Kenya = 91,
  Kiribati = 92,
  KoreaNorth = 93,
  KoreaSouth = 94,
  Kosovo = 95,
  Kuwait = 96,
  Kyrgyzstan = 97,
  Laos = 98,
  Latvia = 99,
  Lebanon = 100,
  Lesotho = 101,
  Liberia = 102,
  Libya = 103,
  Liechtenstein = 104,
  Lithuania = 105,
  Luxembourg = 106,
  Madagascar = 107,
  Malawi = 108,
  Malaysia = 109,
  Maldives = 110,
  Mali = 111,
  Malta = 112,
  MarshallIslands = 113,
  Mauritania = 114,
  Mauritius = 115,
  Micronesia = 116,
  Moldova = 117,
  Monaco = 118,
  Mongolia = 119,
  Montenegro = 120,
  Morocco = 121,
  Mozambique = 122,
  Myanmar = 123,
  Namibia = 124,
  Nauru = 125,
  Nepal = 126,
  Netherlands = 127,
  NewZealand = 128,
  Nicaragua = 129,
  Niger = 130,
  Nigeria = 131,
  NorthMacedonia = 132,
  Norway = 133,
  Oman = 134,
  Pakistan = 135,
  Palau = 136,
  Panama = 137,
  PapuaNewGuinea = 138,
  Paraguay = 139,
  Peru = 140,
  Philippines = 141,
  Poland = 142,
  Portugal = 143,
  Qatar = 144,
  Romania = 145,
  Russia = 146,
  Rwanda = 147,
  SaintKittsAndNevis = 148,
  SaintLucia = 149,
  SaintVincentAndTheGrenadines = 150,
  Samoa = 151,
  SanMarino = 152,
  SaoTomeAndPrincipe = 153,
  SaudiArabia = 154,
  Senegal = 155,
  Serbia = 156,
  Seychelles = 157,
  SierraLeone = 158,
  Singapore = 159,
  Slovakia = 160,
  Slovenia = 161,
  SolomonIslands = 162,
  Somalia = 163,
  SouthAfrica = 164,
  SouthSudan = 165,
  Spain = 166,
  SriLanka = 167,
  Sudan = 168,
  Suriname = 169,
  Sweden = 170,
  Switzerland = 171,
  Syria = 172,
  Taiwan = 173,
  Tajikistan = 174,
  Tanzania = 175,
  Thailand = 176,
  Togo = 177,
  Tonga = 178,
  TrinidadAndTobago = 179,
  Tunisia = 180,
  Turkey = 181,
  Turkmenistan = 182,
  Tuvalu = 183,
  Uganda = 184,
  Ukraine = 185,
  UnitedArabEmirates = 186,
  UnitedKingdom = 187,
  Uruguay = 188,
  Uzbekistan = 189,
  Vanuatu = 190,
  VaticanCity = 191,
  Venezuela = 192,
  Vietnam = 193,
  Yemen = 194,
  Zambia = 195,
  Zimbabwe = 196
}
export enum DisplayFormat {
  Detailed = 'detailed',
  Name = 'name'
}

export enum CommunicationType {
  Mobile = 1,
  Email = 2
}
export enum UserType {
  Tenant = 1,
  Others = 2
}
export enum AddressFormatOptions {
  SingleLine = 1,
  DoubleLine = 2
}
export enum AreaRegionsCountries {
  Unknown = -1,
  Canada = 1,
  UnitedStates = 2,
  Mexico = 3
}
export enum PolicyAmount {
  USD = 1,
  CAD = 2,
  MexicanPeso = 3
}
export enum InsuranceType {
  Cargo = 1,
  Auto = 2,
  CargoLiability = 3,
  MotorTruck = 4,
  Damage = 5,
  Marine = 6,
  AirOrAviation = 7,
  Other = 8
}
export enum PhoneType {
  Home = 1,
  Work = 2,
  Mobile = 3,
  Fax = 4,
  Other = 5
}
export declare enum TimeZone {
  Canada_Atlantic = 1,
  Canada_Central = 2,
  Canada_Eastern = 3,
  Canada_Mountain = 4,
  Canada_Newfoundland = 5,
  Canada_Pacific = 6,
  Canada_Saskatchewan = 7,
  Canada_Yukon = 8,
  Mexico_BajaNorte = 9,
  Mexico_BajaSur = 10,
  Mexico_General = 11,
  US_Alaska = 12,
  US_Arizona = 13,
  US_Central = 14,
  US_Eastern = 15,
  US_Hawaii = 16,
  US_Mountain = 17,
  US_Pacific = 18,
  Asia_Shanghai = 19,
  Asia_Urumqi = 20,
  Europe_Berlin = 21,
  Europe_London = 23
}

export enum ServiceChargeType {
  Standard = 1,
  Premium = 2
}

export enum ServiceType {
  Solo = 1,
  Team = 2
}

export enum TrailerHandlingStrategy {
  None = 0,
  LiveLoadUnload = 1,
  DropOnly = 2,
  DropAndHook = 3,
  HookOnly = 4
}

export enum TransportStatus {
  Unknown = 0,
  Created = 1,
  BidPosted = 2,
  Rated = 3,
  Tendered = 4,
  TenderAccepted = 5,
  PickedUp = 6,
  InTransit = 7,
  Delivered = 8,
  Cancelled = 9,
  TruckOrderNotUsed = 10,
  Closed = 11,
  Archived = 12
}

export enum ShipmentStatus {
  Unknown = 0,
  Created = 1,
  ReadyForPickup = 2,
  Hold = 3,
  PickupStarted = 4,
  PickedUp = 5,
  InTransit = 6,
  DeliveryStarted = 7,
  Delivered = 8,
  ReadyToInvoice = 9,
  OnInvoice = 10,
  Closed = 11,
  Cancelled = 12
}

// Mirrors TMS.Types' ShipmentHolds; the API serializes it as a number (bit flags).
// A hold is an overlay on the shipment's lifecycle status, not a status of its own.
export enum ShipmentHolds {
  None = 0,
  MovementHold = 1,
  InvoiceHold = 2
}

// True when the holds flags carry the given hold. Absent holds (null/undefined) read as None,
// and None is never reported as held.
export function hasShipmentHold(
  holds: number | null | undefined,
  hold: ShipmentHolds
): boolean {
  if (hold === ShipmentHolds.None) return false;
  return ((holds ?? ShipmentHolds.None) & hold) === hold;
}

export enum LocationSearchAlgorithm {
  Locations = 1,
  MostFrequentlyUsed = 2,
  LaneHistory = 3
}

export enum Shape {
  None = 0,
  Cubic = 1,
  Cylindrical = 2,
  Other = 3
}
